import {Component, ElementRef, Input, OnInit, SimpleChanges, ViewChild} from "@angular/core";
import {ConfigServiceProvider} from "../../../modules/core/services/config-service/config-service";
import {HttpClient} from "@angular/common/http";

@Component({
  selector: "sellions-secured-bg",
  template: `
    <div #secured [class]="className"></div>
  `
})
export class SellionsSecuredBgComponent implements OnInit {
  @Input() url: string;
  @Input("classname") className: string;
  @ViewChild("secured", { read: ElementRef }) securedDiv: ElementRef;
  src: string;
  photoPlceholderUrl = "assets/imgs/photo_placeholder.png";
  constructor(
    private configService: ConfigServiceProvider,
    private http: HttpClient
  ) {}

  ngOnInit() {
    this.addPhoto();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.url) {
      this.addPhoto();
    }
  }

  addPhoto(): void {
    if (this.url && this.url !== this.photoPlceholderUrl) {
      this.src = this.configService.apiBaseUrl.slice(0, -1) + this.url;
      this.http
        .get(this.src, { responseType: "blob" })
        .toPromise()
        .then(res => {
          let blob = URL.createObjectURL(res);
          this.updatePhotoUrl(blob);

        })
        .catch(res => {
          console.error("[SECURED-BG]", res);
          this.setDefaultPhoto();
        });
    } else {
      this.setDefaultPhoto();
    }
  }

  updatePhotoUrl(url:string): void {
    this.securedDiv.nativeElement.style.backgroundImage = "url(" + url + ")";
  }

  setDefaultPhoto(): void {
    this.src = this.photoPlceholderUrl;
    this.updatePhotoUrl(this.src);
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/sellions-secured-bg/sellions-secured-bg.ts